import { all } from 'redux-saga/effects'
import { statisticsUserSagas } from './statistics/statistics.user.sagas'
import { statisticsEditorSagas } from './statistics/statistics.editor.sagas'

export function * statisticsRootSagas () {
  yield all([
    statisticsUserSagas(),
    statisticsEditorSagas(),
  ])
}
